interface Props {
  readonly className?: string;
  readonly descriptor?: string;
  readonly testId?: string;
}

/**
 * Nxtpath brand block (Field Notes, epic #950): the official brand
 * mark — black rounded tile, three routing lines converging into a
 * right arrow — beside the serif wordmark, the masthead of the ledger.
 *
 * The mark is `public/brand-mark.svg`, the same graphic as the favicon
 * and the nxtpath.ai site header (its source of truth is the landing
 * app's `public/download/logo-mark.svg`). It is self-colored brand
 * artwork, not themed UI: the tile stays brand black on every surface,
 * so its two colors live in the asset file and `src/` keeps zero color
 * literals (DESIGN.md §8). The tile is its own plate — no border/card
 * wrapper — sized to the same 44px slot the old plate occupied.
 *
 * The rust descriptor is one of the two sanctioned rust moments per
 * screen (DESIGN.md §1.2).
 */
export function BrandWordmark({ className, descriptor, testId }: Props): JSX.Element {
  return (
    <div
      className={['flex items-center gap-3', className ?? ''].join(' ').trim()}
      data-testid={testId}
    >
      <img src="/brand-mark.svg" alt="" aria-hidden="true" className="h-11 w-11 shrink-0" />
      <div className="flex min-w-0 flex-col">
        <span className="block truncate font-display text-title text-ink">Nxtpath</span>
        {descriptor !== undefined && descriptor.length > 0 ? (
          <span className="block truncate font-mono text-mono-label uppercase text-rust-text">
            {descriptor}
          </span>
        ) : null}
      </div>
    </div>
  );
}
